var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "q-field",
        {
          staticClass: "q-field-force-input",
          attrs: {
            label: !_vm.hideLabel ? _vm.$t("email") : "",
            labelWidth: 2,
            icon: _vm.showIcon ? "email" : undefined
          }
        },
        [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { class: _vm.columnWidth },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "no-margin",
                    attrs: {
                      error: _vm.errors.has("email_" + _vm.id),
                      "error-label": _vm.errors.first("email_" + _vm.id)
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "email|max:255",
                          expression: "'email|max:255'",
                          modifiers: { disable: true }
                        }
                      ],
                      attrs: {
                        type: "email",
                        name: "email_" + _vm.id,
                        "data-vv-as": _vm.$t("email"),
                        placeholder: "mail@example.com"
                      },
                      model: {
                        value: _vm.email.email,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.email,
                            "email",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "email.email"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isEmpty && _vm.label,
                    expression: "!isEmpty && label"
                  }
                ],
                class: _vm.columnWidth
              },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "no-margin",
                    attrs: {
                      error: _vm.errors.has("emailLabel_" + _vm.id),
                      "error-label": _vm.errors.first("emailLabel_" + _vm.id)
                    }
                  },
                  [
                    _c("label-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "max:255",
                          expression: "'max:255'",
                          modifiers: { disable: true }
                        }
                      ],
                      attrs: {
                        name: "emailLabel_" + _vm.id,
                        labelList: "email"
                      },
                      model: {
                        value: _vm.email.label,
                        callback: function($$v) {
                          _vm.$set(_vm.email, "label", $$v)
                        },
                        expression: "email.label"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }